import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CogniteIcon = function CogniteIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CogniteIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.038 7.29v-.693a.61.61 0 0 0-.618-.606.61.61 0 0 0-.617.606v.883c-.356.08-.768.16-1.18.24V4.59A.61.61 0 0 0 9 4h-.003a.6.6 0 0 0-.605.589v3.426a.2.2 0 0 0-.11.027c-.378.08-.731.159-1.085.238l-.012.003v-2.65a.6.6 0 0 0-.603-.573.6.6 0 0 0-.603.573V8.55l-.336.063c-.305.058-.588.112-.87.151V7.4a.6.6 0 0 0-.603-.566.6.6 0 0 0-.603.566v1.525c-1.37.16-2.165.107-2.248-.135-.17-.355.795-.835 1.268-1.07l.157-.08v-.027h-.027c-.356.134-1.892.75-1.7 1.284.192.59 2.55.75 7.458-.428 4.111-.99 6.003-1.178 6.195-.803.137.32-.878.936-1.864 1.364a.1.1 0 0 0-.028.08c.027.027.055.054.083.027.355-.134 2.22-.91 2.137-1.552-.081-.428-1.068-.562-2.96-.294m-8.466 3.267v-.448q.6-.034 1.194-.133v.581a.59.59 0 0 1-.597.573.59.59 0 0 1-.597-.573m2.41-.78v1.632a.59.59 0 0 0 .585.59.59.59 0 0 0 .609-.567V9.537q-.59.155-1.194.24m4.755-1.005q.701-.12 1.238-.239v.931a.6.6 0 0 1-.604.585h-.004a.62.62 0 0 1-.438-.164.6.6 0 0 1-.192-.42zm-2.327.533h-.083v1.146a.615.615 0 0 0 .62.582.615.615 0 0 0 .619-.582V9.038l-.26.057a25 25 0 0 0-.896.21",
      clipRule: "evenodd"
    })
  }));
};

export { CogniteIcon };
